import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
import { ClockIcon } from '../atoms/icons/clock_icon';
// カウントレッスンのカード。レッスンのテーマカラーを背景にして名前・説明・時間・コーチ画像を表示する
export const CountLessonCard = ({ lesson, classObject, onClick }) => (React.createElement("div", { className: css(styles.card, classObject), style: { backgroundColor: lesson.colorCode }, onClick: onClick },
    React.createElement("div", { className: css(styles.body) },
        React.createElement("div", { className: css(styles.name) }, lesson.name),
        React.createElement("div", { className: css(styles.description) }, lesson.description),
        React.createElement("div", { className: css(styles.duration) },
            React.createElement(ClockIcon, { color: Colors.White }),
            React.createElement("span", { className: css(styles.durationText) },
                lesson.durationMinutes,
                "\u5206"))),
    lesson.coachImageSrc && (React.createElement("div", { className: css(styles.coachImageWrapper) },
        React.createElement("img", { className: css(styles.coachImage), src: lesson.coachImageSrc, alt: lesson.name })))));
const styles = StyleSheet.create({
    card: {
        display: 'flex',
        gap: 8,
        alignItems: 'stretch',
        cursor: 'pointer',
        width: 361,
        maxWidth: '100%',
        paddingLeft: 20,
        borderRadius: 14,
        overflow: 'hidden',
    },
    body: {
        flex: 1,
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        padding: '18px 0',
    },
    name: {
        fontSize: 20,
        fontWeight: 'bold',
        lineHeight: 1,
        color: Colors.White,
    },
    description: {
        fontSize: 14,
        lineHeight: 1.4,
        letterSpacing: 0.56,
        color: Colors.White,
    },
    duration: {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
    },
    durationText: {
        fontSize: 14,
        fontWeight: 500,
        lineHeight: 1,
        color: Colors.White,
    },
    // カード高さいっぱいに表示するコーチ画像。カードの高さはテキスト側で決まるよう絶対配置にする
    coachImageWrapper: {
        position: 'relative',
        alignSelf: 'stretch',
        width: 98,
        flexShrink: 0,
    },
    coachImage: {
        position: 'absolute',
        top: 12,
        right: 8,
        width: 'calc(100% - 12px)',
        height: 'calc(100% - 12px)',
        objectFit: 'cover',
        objectPosition: 'top',
        borderRadius: 4,
    },
});
